<template>
  <div class="case-detail">
    <Row :gutter="10">
      <Col span="12">
        <Card>
          <Patient ref="patient" @patient="getPatient" :zjlxList="zjlxList" :bllxList="bllxList" :sjbmList="sjbmList" :bllbList="bllbList" :fxffList="fxffList" :rslxList="rslxList" :patInfo="patInfo"></Patient>
        </Card>
      </Col>
      <Col span="5">
      <Card>
        <h1 class="case-detail-title">{{$t('editCase.sampleSlide')}}</h1>
        <div style="height:560px;overflow-y:auto;overflow-x:hidden;">
          <div style="height:22px">
            <button type="button" @click="appendSample" class="ivu-btn ivu-btn-primary ivu-btn-small ivu-btn-icon-only" style="width: 32px; height: 22px;">
              <i class="ivu-icon ivu-icon-md-add"></i>
            </button>
          </div>
          <div style="line-height: 24px;height: 560px;max-height: 560px;">
            <Tree :data="sampleTreeData" class="demo-tree-render"></Tree>
          </div>
        </div>
      </Card>
      </Col>
      <Col span="6">
        <Card>
          <div v-if="showSample">
            <Sample ref="sample" @sample="getSample" :fxffList="fxffList" :rslxList="rslxList" :sampleInfo="sampleInfo" v-on:reLoadSampleSlideList="getCaseDetail"></Sample>
          </div>
          <div v-if="showSlide">
            <Slide ref="slide" @slide="getSlide" :slideId="editSlideId" :fxffList="fxffList" :rslxList="rslxList" :slideInfo="slideInfo" :materialList="materialList" v-on:reLoadSampleSlideList="getCaseDetail"></Slide>
          </div>
        </Card>
      </Col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <!-- 新增样本弹窗 -->
    <div v-if="addSample">
      <Modal v-model="addSample" :title="$t('editCase.addSample')">
        <AddNewSample :caseId="caseId" :fxffList="fxffList" :rslxList="rslxList" v-on:reLoadSampleSlideList="getCaseDetail"></AddNewSample>
        <div slot="footer"></div>
      </Modal>
    </div>
    <!-- 新增玻片弹窗 -->
    <div v-if="addSlide">
      <Modal v-model="addSlide" :title="$t('editCase.addSlide')">
        <AddNewSlide :sampleId="editSampleId" :fxffList="fxffList" :rslxList="rslxList" v-on:reLoadSampleSlideList="getCaseDetail"></AddNewSlide>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Patient from './Patient'
import Sample from './Sample'
import Slide from './Slide'
import AddNewSample from './AddNewSample'
import AddNewSlide from './AddNewSlide'
export default{
  components: {Patient, Sample, Slide, AddNewSample, AddNewSlide},
  props: {
    caseId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      spinShow: true,
      fxffList: [],
      rslxList: [],
      bllxList: [],
      sjbmList: [],
      bllbList: [],
      zjlxList: [],
      patInfo: {},
      patient: '',
      sampleSlideList: [],
      materialList: [],
      showSample: false,
      showSlide: false,
      sampleInfo: {},
      slideInfo: {},
      sample: '',
      slide: '',
      sampleTreeData: [],
      addSample: false,
      addSlide: false,
      editSampleId: '',
      editSlideId: ''
    }
  },
  beforeMount () {
    this.$vue = this
    this.getDicInfo()
    this.getCaseDetail()
  },
  methods: {
    // 获取字典表信息
    async getDicInfo () {
      let params = new URLSearchParams()
      // 分析方法，染色类型，病理类型，送检部门，病例类别，证件类型
      let types = 'fxff,rslx,bllx,sjbm,bllb,zjlx'
      params.append('types', types)
      let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.fxffList = data.fxff
        this.rslxList = data.rslx
        this.bllxList = data.bllx
        this.sjbmList = data.sjbm
        this.bllbList = data.bllb
        this.zjlxList = data.zjlx
      }
    },
    // 获取到病例病人信息
    getPatient (patient) {
      this.patient = patient
    },
    // 获取病例详情信息
    async getCaseDetail () {
      let params = new URLSearchParams()
      params.append('case_id', this.caseId.toString())
      let suc = await this.$http.post(this.$vue.getData('GET_CASE_DETAIL_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.patInfo = data.patInfo
        // 适应树形组件
        this.suitTreeComp(data.sampleList)
        // 页面第一次加载时最右侧展示的样本id
        this.getSampleDetail(data.sample_id)
      }
      this.spinShow = false
      this.addSample = false
      this.addSlide = false
      // debugger
      // console.log(this.patInfo.send_date)
      // console.log(typeof (this.patInfo.send_date))
    },
    // 获取到样本信息
    getSample (sample) {
      this.sample = sample
    },
    // 查询样本详情信息
    async getSampleDetail (sampleId) {
      let params = new URLSearchParams()
      params.append('sample_id', sampleId)
      let succ = await this.$http.post(this.$vue.getData('GET_SAMPLE_DETAIL_URL'), params)
      if (succ.data.result === '1') {
        let data1 = succ.data.data
        this.sampleInfo = data1.sampleInfo
        this.showSample = true
        this.showSlide = false
      }
    },
    // 获取到拨片信息
    getSlide (slide) {
      this.slide = slide
    },
    // 适应树形组件
    suitTreeComp (list) {
      this.sampleTreeData = []
      // 遍历根节点，添加数据
      list.forEach((value, index, array) => {
        let children = []
        // 遍历子节点，添加数据
        // debugger
        if (value.slides.length > 1 || (value.slides.length === 1 && value.slides[0].slide_code !== undefined)) {
          value.slides.forEach((value, index, array) => {
            let slide = {
              title: value.slide_code,
              expand: true,
              slideData: value,
              render: (h, { root, node, data }) => {
                return h('div', {
                  style: {
                    // marginTop: '-32px',
                    fontSize: '13px'
                    // marginLeft: '10px'
                  },
                  on: {
                    click: () => {
                      // 查询玻片详情
                      this.getSlideDetail(data.slideData.slide_id)
                    }
                  }
                }, [
                  // h('a', data.title)
                  h('span', [
                    h('span', data.title)
                  ]),
                  h('span', {
                    style: {
                      display: 'inline-block',
                      float: 'right'
                    }
                  }, [
                    h('Button', {
                      props: {
                        icon: 'md-remove',
                        type: 'primary',
                        size: 'small'
                      },
                      style: {
                        width: '28px',
                        height: '22px',
                        marginRight: '18px',
                        color: '#2d8cf0',
                        backgroundColor: '#fff'
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: this.$t('editCase.removeSlide'),
                            content: '<p>' + this.$t('editCase.removeSlideTip') + '</p>',
                            onOk: () => {
                              this.removeSlide(data.slideData.slide_id)
                            },
                            onCancel: () => {
                              // this.$Message.info('Clicked cancel')
                            }
                          })
                        }
                      }
                    })
                  ])
                ])
              }
            }
            children.push(slide)
          })
        }
        let item = {
          title: value.sample_code,
          sampleId: value.sample_id,
          expand: true,
          render: (h, { root, node, data }) => {
            return h('a', {
              style: {
                display: 'inline-block',
                fontSize: '17px',
                width: '100%'
              },
              on: {
                click: () => {
                  // 查询样本详情
                  this.getSampleDetail(data.sampleId)
                }
              }
            }, [
              h('span', [
                h('span', data.title)
              ]),
              h('span', {
                style: {
                  display: 'inline-block',
                  float: 'right',
                  marginRight: '18px'
                }
              }, [
                h('Button', {
                  props: {
                    icon: 'md-add',
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    width: '28px',
                    height: '22px'
                  },
                  on: {
                    click: () => { this.appendSlide(data.sampleId) }
                  }
                })
              ])
            ])
          },
          children: children
        }
        this.sampleTreeData.push(item)
      })
    },
    appendSample () {
      this.addSlide = false
      this.addSample = true
    },
    appendSlide (sampleId) {
      this.editSampleId = sampleId
      this.addSlide = true
    },
    async removeSlide (slideId) {
      let params = new URLSearchParams()
      params.append('slideId', slideId)
      let succ = await this.$http.post(this.$vue.getData('DEL_SLIDE_BY_SLIDEID_URL'), params)
      if (succ.data.result === '1') {
        this.getCaseDetail()
        this.success()
      }
    },
    // 查询玻片详情信息
    async getSlideDetail (slideId) {
      let params = new URLSearchParams()
      params.append('slide_id', slideId)
      let succ = await this.$http.post(this.$vue.getData('GET_SLIDE_DETAIL_URL'), params)
      if (succ.data.result === '1') {
        let data1 = succ.data.data
        this.slideInfo = data1.slideInfo
        this.materialList = data1.slideInfo.meterialsList
        this.showSlide = true
        this.editSlideId = slideId
        this.showSample = false
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.removeSlideSuccessfully')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.removeSlideFailed')
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .case-detail
    .demo-tree-render
    .ivu-tree-title
      width: 100%
</style>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .case-detail-title
    font-weight bolder
    font-size 20px
    color #2d8cf0
    margin-bottom 24px
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/CaseDetail.vue